import React, { useEffect, useRef, useState } from 'react'
import { getSubAccountLocations } from '../../services/userservice';
import { retailBulkSave } from '../../services/bookingservice';
import { useSelector, useDispatch } from 'react-redux';
import { setLoading } from '../../redux/appSlice';
import { setData, setFileLen, setFileType, setGrid, setGridStatus, setFileName } from '../../redux/bulkBookingSlice';
import { calculateErrors } from './calculateerrors';

const Form = ({ myWorker, validateExcel }) => {
    const dispatch = useDispatch();
    const state = useSelector(state => { return { appData: state.appData, bulkBookingData: state.bulkBookingData } });
    const { destinations, loading, userInfo, types, subaccounts, services } = state.appData;
    const {
        data,
        fileLen,
        fileType,
        fileName,
        grid } = state.bulkBookingData;

    const dests = destinations.map(x => x.text);

    const [locations, setLocations] = useState([]);

    const fileRef = useRef(null);

    useEffect(() => {
        myWorker.onmessage = function (event) {
            fileRef.current.value = null;
            dispatch(setFileLen({ data: 0 }));
            dispatch(setFileName({ data: '' }));
            const { sts, msg, dt } = event.data;
            if (sts === 0) {
                if (dt.length > 999) {
                    alert('Maximum Booking length is 1000.');
                    return false;
                }
                dispatch(setGrid({ data: dt }));
            } else {
                alert(msg);
            }
            dispatch(setLoading({ data: false }));
        }
    }, [])

    const onUpload = async () => {
        dispatch(setLoading({ data: false }));
        const file = fileRef.current.files[0];
        const type = data.isCod && data.autoCN === false ? 1 :
            data.isCod && data.autoCN ? 2 :
                !data.isCod && data.autoCN ? 3 : 4;
        myWorker.postMessage({ file: file, type: type, destinations: destinations });
    }

    const onSave = async () => {

        if (validateExcel("save")) {
            var d = {
                user: {
                    id: userInfo.id,
                    isDuplicateOrderAllowed: userInfo.isDuplicateOrderAllowed
                },
                accountNo: data.accountNo,
                locationId: Number(data.locationId),
                subAccountId: Number(data.subAccountId),
                autoCN: data.autoCN,
                bookings: grid.map(y => {
                    return {
                        cn: y.ConsignmentNo,
                        cnType: y.SpecialHandling == 'yes' ? 13 : 12,
                        consignee: y.ConsigneeName,
                        consigneeAddress: y.ConsigneeAddress,
                        consigneePhone: y.ConsigneeMobileNumber,
                        consigneeEmail: y.ConsigneeEmail,
                        destinationId: y.DestinationId,
                        pcs: y.Pieces,
                        serviceType: y.ServiceType,
                        weight: y.Weight,
                        productDetails: y.ProductDetails,
                        remarks: y.Remarks,
                        refNo: y.CustomerReferenceNumber,
                        codAmount: y.CODAmount,
                        totalAmount: String(y.totalAmount),
                        gst: String(y.gst)
                    }
                })
            };
            dispatch(setLoading({ data: true }));
            const rs = await retailBulkSave(d);
            dispatch(setLoading({ data: false }));
            if (rs.ok) {
                alert("Bookings Saved");
                dispatch(setGrid({ data: [] }));
                dispatch(setGridStatus({ data: rs.data }));
            } else {
                alert(rs.msg);
            }
        }
    }

    useEffect(() => {
        dispatch(setGrid({ data: [] }));
    }, [data.subAccountId])

    const fileUploadCheck = (event) => {
        if (!data.subAccountId) {
            alert('Select Sub Account');
            event.preventDefault();
            return false;
        }
        if (!data.locationId) {
            alert('Select Location');
            event.preventDefault();
            return false;
        }
    }

    return (
        <>
            <div className="row">
                <datalist id="dests">
                    {
                        dests.map((x, index) => <option key={index} value={x} />)
                    }
                </datalist>
                <div className="col-lg">
                    <label>Type</label>
                    <select className="form-select" value={data.isCod ? 1 : 0} onChange={(e) => {
                        const d = { ...data, isCod: e.target.value == 1, locationId: '', autoCN: null, subAccountId: '' };
                        dispatch(setData({ data: d }));
                        setLocations([]);
                    }}>
                        {
                            types.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg">
                    <label>Sub Account</label>
                    <select className="form-select" value={data.subAccountId} onChange={async (e) => {
                        const val = e.target.value;
                        const autoCn = e.target[e.target.selectedIndex].getAttribute('data-autocn');
                        const accno = e.target[e.target.selectedIndex].getAttribute('data-accno');
                        const d = { ...data, subAccountId: val, locationId: '', autoCN: autoCn ? autoCn === 'true' : null, accountNo: accno };
                        dispatch(setData({ data: d }));
                        if (val) {
                            // const locs = await getLocations(userInfo?.id, accno)
                            const locs = await getSubAccountLocations(userInfo.id, val)
                            if (locs)
                                setLocations(locs);
                        } else {
                            setLocations([]);
                        }
                    }}>
                        <option value="" data-autocn={null} data-accno="">Select Sub Account</option>
                        {
                            subaccounts.filter(x => x.isCod == data.isCod).map((x, index) => <option key={index} value={x.id} data-autocn={x.autoCN} data-accno={x.accountNo}>{x.name}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg">
                    <label>Locations</label>
                    <select className="form-select" onChange={(e) => {
                        const val = e.target.value;
                        const branch = e.target[e.target.selectedIndex].getAttribute('data-branch')
                        const d = { ...data, locationId: val, branch: branch };
                        dispatch(setData({ data: d }));
                    }}>
                        <option value="">Select Location</option>
                        {
                            locations.map((x, index) => <option key={index} value={x.value} data-branch={x.branch}>{x.text}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg">
                    <label>File</label>
                    <input
                        onClick={fileUploadCheck}
                        type='file'
                        ref={fileRef}
                        className='form-control'
                        onChange={(e) => {
                            dispatch(setFileName({ data: e.target.files.length > 0 ? e.target.files[0].name : '' }))
                            dispatch(setFileLen({ data: e.target.files.length }))
                        }}
                        style={{
                            height: '37px',
                            padding: '7.5px 13px'
                        }}
                    />
                </div>
                <div className="col-lg" style={{ textAlign: "right" }}>
                    {
                        function () {
                            if (data.isCod && data.autoCN === false) {
                                return <>
                                    <a href="Sample1.xlsx" download className="btn btn-sm btn-primary badge-orange" style={{
                                        marginTop: '1.5rem', height: '37px',
                                        padding: '7.5px 13px'
                                    }}>Excel Sample</a>
                                </>
                            } else if (data.isCod && data.autoCN === true) {
                                return <>
                                    <a href="Sample2.xlsx" download className="btn btn-sm btn-primary badge-orange" style={{
                                        marginTop: '1.5rem', height: '37px',
                                        padding: '7.5px 13px'
                                    }}>Excel Sample</a>
                                </>
                            } else if (!data.isCod && data.autoCN === true) {
                                return <>
                                    <a href="Sample3.xlsx" download className="btn btn-sm btn-primary badge-orange" style={{
                                        marginTop: '1.5rem', height: '37px',
                                        padding: '7.5px 13px'
                                    }}>Excel Sample</a>
                                </>
                            }
                            else if (!data.isCod && data.autoCN === false) {
                                return <>
                                    <a href="Sample4.xlsx" download className="btn btn-sm btn-primary badge-orange" style={{
                                        marginTop: '1.5rem', height: '37px',
                                        padding: '7.5px 13px'
                                    }}>Excel Sample</a>
                                </>
                            }
                        }()
                    }
                </div>
            </div>
            <div id="errorDiv">
                <div className="table table-sm table-bordered" style={{ color: 'red', marginTop: '30px' }}>
                    <div className='row' style={{ maxHeight: '200px', overflow: 'auto' }}>
                        {
                            calculateErrors(grid, destinations, userInfo, services).length > 0 && <span style={{ fontSize: "20px" }}>Error Counts ({calculateErrors(grid, destinations, userInfo, services).length}){" - "}
                                {calculateErrors(grid, destinations, userInfo, services)[0].fieldName}: {calculateErrors(grid, destinations, userInfo, services)[0].error} {" "} <button type="button" className="btn btn-primary" onClick={() => {
                                    document.getElementById(`${calculateErrors(grid, destinations, userInfo, services)[0].key}${calculateErrors(grid, destinations, userInfo, services)[0].index + 1}`).focus({ focusVisible: true })
                                }}>Go</button></span>}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg" style={{ textAlign: 'right' }}>
                    <button type="button" className="btn btn-primary" style={{ marginTop: '1.5rem' }} disabled={fileLen === 0} onClick={onUpload}>Upload</button>
                    <button type="button" className="btn btn-primary" style={{ marginTop: '1.5rem', marginLeft: 2 }} disabled={grid.length <= 0} onClick={onSave}>Save</button>
                </div>
            </div>
        </>
    )
}

export default Form;
